__turbopack_context__.v({
  "link": "link_button-module__asjQ3a__link",
});
